export const CATEGORIES = [
  "Starting a Business", "Branding and Positioning", "Marketing", "Sales",
  "E-commerce", "Finance", "Hiring", "Operations and SOPs",
  "AI and Automation", "Founder Productivity",
];

export const STAGES = [
  { value: "idea", label: "Idea" },
  { value: "early", label: "Early" },
  { value: "growth", label: "Growth" },
  { value: "scale", label: "Scale" },
];

export const FORMATS = [
  { value: "template", label: "Template" },
  { value: "playbook", label: "Playbook" },
  { value: "checklist", label: "Checklist" },
  { value: "guide", label: "Guide" },
  { value: "spreadsheet", label: "Spreadsheet" },
  { value: "prompt-pack", label: "Prompt Pack" },
  { value: "sop", label: "SOP" },
  { value: "notion", label: "Notion" },
];

export const TIERS = {
  free: { label: "Free", color: "text-slate-600 bg-slate-100" },
  premium: { label: "Premium", color: "text-electric bg-blue-50" },
  pro: { label: "Pro", color: "text-emerald-700 bg-emerald-50" },
};

export const TIER_RANK = { free: 0, premium: 1, pro: 2 };

export const BUSINESS_TYPES = [
  "Coaching / Consulting", "D2C Brand", "E-commerce Seller", "Agency",
  "Freelancer", "SaaS", "Traditional Business Online", "Other",
];
